import savePackageSlice from "../slices/save-package-slice";

export const {
  savedPackageAdded,
  savedPackageRemoved,
  savedPackageChanged,
  savedPackagesReceived,
  savedPackagesCleared,
} = savePackageSlice.actions;
